(function () {
    if (window.greenmotion.isFranchise) return;

    $('.booking-completion').on('blur', '.form-email', storeFormProgress);
    /**
     * Stores form progress
     * @param e
     */
    function storeFormProgress(e) {
        var data = {
            email: getEmail(),
            title: getTitle(),
            first_name: getFirstName(),
            last_name: getLastName(),
        };
        $.post('/api/basket-progress', data, progressSuccess, progressFail);
    }

    /**
     * @returns string
     */
    function getTitle() {
        var selectizeInstance = $('#title').selectize()[0].selectize;
        var opts = selectizeInstance.options;
        return opts[selectizeInstance.items[0]].text;
    }

    /**
     * @returns string
     */
    function getFirstName() {
        return $('#first-name').val();
    }

    /**
     * @returns string
     */
    function getLastName() {
        return $('#last-name').val();
    }

    /**
     * @returns string
     */
    function getEmail() {
        return $('#email').val();
    }

    function progressSuccess(a, b, c) {}

    function progressFail(a, b, c) {}
})();
